import { createSlice } from "@reduxjs/toolkit";

const initialWorkersState = {
  listLoading: false,
  listLoader: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  assetClassForEdit: {
    id: undefined,
    name: "",
  },
  message: null,
  messageType: null,
  showMessage: false,
  stateData: {},
  selectedTab: 0,
  assetClassId: undefined,
  showAssetClassPopover: false,
  showDeleteDialog: false,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const assetClassSlice = createSlice({
  name: "assetClass",
  initialState: initialWorkersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // category loader
    assetClassListLoading: (state, action) => {
      state.listLoading = action.payload;
    },
    assetClassList: (state, action) => {
      const { result, count } = action.payload;

      state.totalCount = count;
      state.entities = result;
      state.listLoader = false;
    },
    listLoad: (state, action) => {
      state.listLoader = action.payload;
    },
    loadAssetClassForEdit: (state, action) => {
      const payload = action.payload;

      state.assetClassForEdit.assetClass = payload.name;
      state.assetClassForEdit.id = payload.id;
    },
    loadAssetClassMessage: (state, action) => {
      const { message, type } = action.payload;

      state.message = message;
      state.messageType = type;
      state.showMessage = true;
    },
    loadState: (state, action) => {
      state.stateData = action.payload;
    },
    setTab: (state, action) => {
      state.selectedTab = action.payload;
    },
    openAssetClassApprove: (state, action) => {
      const { assetClassId } = action.payload;

      state.assetClassId = assetClassId;
      state.showAssetClassPopover = !state.showAssetClassPopover;
    },
    setDeleteDialogData: (state, action) => {
      const { assetClassId } = action.payload;

      state.showDeleteDialog = !state.showDeleteDialog;
      state.assetClassId = assetClassId;
    },
  },
});
